<template>
  <label data-sb-regression="sb-label">
    <!--
      @slot text, components, or HtmlElements as children of the component
    -->
    <slot />
  </label>
</template>

<script>
/**
 * Label element used for inputs
 */
export default {
  name: 'SbLabel',
};
</script>

<style lang="scss" scoped>
@import '@src/components/Label/style/sb-label.scss';
</style>
